<template>
  <div v-if="(user_accesses && userService.hasAccess(user_accesses, ['admin', 'view_client']))" class="p-grid crud-demo">
    <div class="p-col-12">
      <div class="card">
        <Toast/>
        <Toolbar class="p-mb-4 table-toolbar">
          <template slot="left">
            <Button v-if="user_accesses && userService.hasAccess(user_accesses, ['admin', 'add_client'])"
                    label="New"
                    icon="pi pi-plus"
                    class="p-button-success p-mr-2"
                    @click="openNew"/>
            <Button v-if="user_accesses && userService.hasAccess(user_accesses, ['admin', 'delete_client'])"
                    label="Delete"
                    icon="pi pi-trash"
                    class="p-button-danger"
                    @click="confirmDeleteSelected"
                    :disabled="!selectedClients || !selectedClients.length"/>
          </template>

          <template slot="right">
            <!-- <FileUpload mode="basic" accept="image/*" :maxFileSize="1000000" label="Import" chooseLabel="Import"
                        class="p-mr-2 p-d-inline-block" :disabled="true"/> -->
            <Button label="Export" icon="pi pi-upload" class="p-button-info" @click="exportCSV($event)"/>
          </template>
        </Toolbar>

        <DataTable ref="dt" :value="clients" :selection.sync="selectedClients" dataKey="id" :paginator="true" :rows="10"
                   :filters="filters"
                   paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                   :rowsPerPageOptions="[5,10,25]"
                   currentPageReportTemplate="Showing {first} to {last} of {totalRecords} clients">
          <template #header>
            <div class="table-header">
              <h5 class="p-m-0">Manage Clients</h5>
              <span class="p-input-icon-left">
                                <i class="pi pi-search"/>
                                <InputText v-model="filters['global']" placeholder="Search..."/>
                            </span>
            </div>
          </template>

          <Column selectionMode="multiple" headerStyle="width: 4rem"></Column>
          <!-- <Column header="Image">
            <template #body="slotProps">
              <img :src="slotProps.data.image ? 'assets/layout/images/clients/' + slotProps.data.image : 'assets/layout/images/clients/default.png'"
                   :alt="slotProps.data.name" class="product-image"/>
            </template>
          </Column> -->
          <Column field="name" header="Company" sortable></Column>
          <Column field="contact_name" header="Full Name" sortable></Column>
          <Column field="contact_mobile" header="Contact No." sortable></Column>
          <!--                    <Column field="contact_email" header="Contact Email" sortable></Column>-->
          <!-- <Column field="rating" header="Reviews" sortable>-->
          <!--                        <template #body="slotProps">-->
          <!--                            <Rating :value="slotProps.data.rating" :readonly="true" :cancel="false" />-->
          <!--                        </template>-->
          <!--                    </Column>-->
          <!-- <Column field="status" header="Status" sortable>
            <template #body="slotProps">
              <span :class="'product-badge status-' + slotProps.data.status.toLowerCase()">{{slotProps.data.status}}</span>
            </template>
          </Column> -->
          <Column>
            <template #body="slotProps">
              <Button :icon="user_accesses && userService.hasAccess(user_accesses, ['admin', 'edit_client']) ? 'pi pi-pencil' : 'pi pi-eye'"
                      class="p-button-rounded p-button-warning p-mr-2"
                      @click="editClient(slotProps.data)"/>
              <Button icon="pi pi-trash"
                      v-if="user_accesses && userService.hasAccess(user_accesses, ['admin', 'delete_client'])"
                      class="p-button-rounded p-button-danger"
                      @click="confirmDeleteClient(slotProps.data)"/>
            </template>
          </Column>
        </DataTable>

        <div v-if="clients == null" class="loader">
          <scale-out class="loader-style"></scale-out>
        </div>

        <Dialog :visible.sync="clientDialog" :style="{width: '450px'}" header="Client Details" :modal="true"
                class="p-fluid">
          <img :src="'assets/layout/images/product/' + client.image" :alt="client.image" class="product-image"
               v-if="client.image"/>
          <div class="p-field">
            <label for="name">Name</label>
            <InputText id="name" v-model.trim="client.name" required="true" autofocus
                       :class="{'p-invalid': submitted && !client.name}"/>
            <small class="p-invalid" v-if="submitted && !client.name">Name is required.</small>
          </div>
          <div class="p-field">
            <label for="description">Description</label>
            <Textarea id="description" v-model="client.description" required="true" rows="3" cols="20"/>
          </div>

          <div class="p-field">
            <label class="p-mb-3">Company</label>
            <div class="p-formgrid p-grid">
              <div class="p-field-radiobutton p-col-6">
                <RadioButton id="company_name1" name="company_name1" value="company_name1"
                             v-model="client.company_name"/>
                <label for="company_name1">Accessories</label>
              </div>
              <div class="p-field-radiobutton p-col-6">
                <RadioButton id="company_name2" name="company_name2" value="company_name2"
                             v-model="client.company_name"/>
                <label for="company_name2">Clothing</label>
              </div>
              <div class="p-field-radiobutton p-col-6">
                <RadioButton id="company_name3" name="company_name3" value="company_name3"
                             v-model="client.company_name"/>
                <label for="company_name3">Electronics</label>
              </div>
              <div class="p-field-radiobutton p-col-6">
                <RadioButton id="company_name4" name="company_name4" value="company_name4"
                             v-model="client.company_name"/>
                <label for="company_name4">Fitness</label>
              </div>
            </div>
          </div>

          <div class="p-formgrid p-grid">
            <div class="p-field p-col">
              <label for="contact_number">Contact Number</label>
              <InputNumber id="contact_number" v-model="client.contact_number" mode="currency" currency="USD"
                           locale="en-US"/>
            </div>
            <div class="p-field p-col">
              <label for="quantity">Quantity</label>
              <InputNumber id="quantity" v-model="client.quantity" integeronly/>
            </div>
          </div>
          <template #footer>
            <Button label="Cancel" icon="pi pi-times" class="p-button-text" @click="hideDialog"/>
            <Button label="Save" icon="pi pi-check" class="p-button-text" @click="saveClient"/>
          </template>
        </Dialog>

        <Dialog :visible.sync="deleteClientDialog" :style="{width: '450px'}" header="Confirm" :modal="true">
          <div class="confirmation-content">
            <i class="pi pi-exclamation-triangle p-mr-3" style="font-size: 2rem"/>
            <span v-if="client">Are you sure you want to delete <b>{{client.name}}</b>?</span>
          </div>
          <template #footer>
            <Button label="No" icon="pi pi-times" class="p-button-text" @click="deleteClientDialog = false"/>
            <Button label="Yes" icon="pi pi-check" class="p-button-text" @click="deleteClient"/>
          </template>
        </Dialog>

        <Dialog :visible.sync="deleteClientsDialog" :style="{width: '450px'}" header="Confirm" :modal="true">
          <div class="confirmation-content">
            <i class="pi pi-exclamation-triangle p-mr-3" style="font-size: 2rem"/>
            <span v-if="client">Are you sure you want to delete the selected clients?</span>
          </div>
          <template #footer>
            <Button label="No" icon="pi pi-times" class="p-button-text" @click="deleteClientsDialog = false"/>
            <Button label="Yes" icon="pi pi-check" class="p-button-text" @click="deleteSelectedClients"/>
          </template>
        </Dialog>
      </div>
    </div>
  </div>

</template>

<script>
  import ClientService from '../../services/ClientService';
  import UserService from '../../services/UserService';
  import {ScaleOut} from 'vue-loading-spinner';

  export default {
    components: { ScaleOut },
    data() {
      return {
        clients: null,
        clientDialog: false,
        deleteClientDialog: false,
        deleteClientsDialog: false,
        client: {},
        selectedClients: null,
        filters: {},
        submitted: false,
        user_accesses: this.$store.state.accesses,
        userService: null,
        clientService: null,
      }
    },
    created() {
      this.clientService = new ClientService();
      this.userService = new UserService();
      if (!this.user_accesses){
        let user_info = this.$store.state.user_info ? JSON.parse(this.$store.state.user_info) : {};
        this.userService.getUserAccesses(user_info.id).then(result => {
          if (result.status === 200) {
            let accesses = result.data.accesses;
            this.$store.state.accesses = accesses;
            this.user_accesses = accesses;
          }
        });
      }
    },
    mounted() {
      this.clientService.listClients().then(response => this.clients = response.data.clients);
    },
    methods: {
      formatCurrency(value) {
        return value.toLocaleString('en-US', {style: 'currency', currency: 'USD'});
      },
      openNew() {
        this.$router.push('/client').catch()
      },
      hideDialog() {
        this.clientDialog = false;
        this.submitted = false;
      },
      saveClient() {
        this.submitted = true;

        if (this.client.name.trim()) {
          if (this.client.id) {
            this.$set(this.clients, this.findIndexById(this.client.id), this.client);
            this.$toast.add({severity: 'success', summary: 'Successful', detail: 'Client Updated', life: 3000});
          } else {
            this.client.id = this.createId();
            this.client.code = this.createId();
            this.client.image = 'product-placeholder.svg';
            this.client.status = 'INSTOCK';
            this.clients.push(this.client);
            this.$toast.add({severity: 'success', summary: 'Successful', detail: 'Client Created', life: 3000});
          }

          this.clientDialog = false;
          this.client = {};
        }
      },
      editClient(client) {
        localStorage.removeItem("client_info");
        this.client = {...client};
        this.$router.push('/client/edit/' + this.client.id).catch()
      },
      confirmDeleteClient(client) {
        this.client = client;
        this.deleteClientDialog = true;
      },
      deleteClient() {
        this.clients = this.clients.filter(val => val.id !== this.client.id);
        this.clientService.deleteClient(this.client.id).then(result => {
          if (result.status === 200) {
            this.$toast.add({
              severity: 'success',
              summary: 'Success Status',
              detail: 'Client Deleted!',
              life: 3000
            });
            this.deleteClientDialog = false;
            this.client = {};
          } else {
            this.$toast.add({
              severity: 'warn',
              summary: 'Failed to delete!',
              detail: result.data.error
            });
          }
        });
        // this.$toast.add({severity:'success', summary: 'Successful', detail: 'Client Deleted', life: 3000});
      },
      findIndexById(id) {
        let index = -1;
        for (let i = 0; i < this.clients.length; i++) {
          if (this.clients[i].id === id) {
            index = i;
            break;
          }
        }

        return index;
      },
      createId() {
        let id = '';
        var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        for (var i = 0; i < 5; i++) {
          id += chars.charAt(Math.floor(Math.random() * chars.length));
        }
        return id;
      },
      exportCSV() {
        this.$refs.dt.exportCSV();
      },
      confirmDeleteSelected() {
        this.deleteClientsDialog = true;
      },
      deleteSelectedClients() {
        this.clients = this.clients.filter(val => !this.selectedClients.includes(val));
        this.clientService.deleteClients(this.selectedClients.map((obj) => obj.id)).then(result => {
          if (result.status === 200) {
            this.$toast.add({
              severity: 'success',
              summary: 'Success Status',
              detail: 'Selected Clients Deleted!',
              life: 3000
            });
            this.deleteClientDialog = false;
            this.client = {};
          } else {
            this.$toast.add({
              severity: 'warn',
              summary: 'Failed to delete selected clients!',
              detail: result.data.error
            });
          }
        });
        this.deleteClientsDialog = false;
        this.selectedClients = null;
      }
    }
  }
</script>

<style scoped lang="scss">
  .table-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .product-image {
    width: 100px;
    border-radius: 50px;
    /*box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);*/
  }

  .p-dialog .product-image {
    width: 150px;
    margin: 0 auto 2rem auto;
    display: block;
  }

  .confirmation-content {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .product-badge {
    border-radius: 2px;
    padding: .25em .5rem;
    text-transform: uppercase;
    font-weight: 700;
    font-size: 12px;
    letter-spacing: .3px;

    &.status-active {
      background: #C8E6C9;
      color: #256029;
    }

    &.status-inactive {
      background: #FFCDD2;
      color: #C63737;
    }
  }
</style>
